import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import Header from '../../components/header/AdminHeader'
import Footer from '../../components/footer/Footer'
import img1 from '../../assets/images/box-item/card-item8.jpg'
import img2 from '../../assets/images/box-item/image-box-10.jpg'
import img3 from '../../assets/images/box-item/image-box-1.jpg'
import img4 from '../../assets/images/box-item/card-item-11.jpg'
import img5 from '../../assets/images/box-item/img1rank.jpg'
import img6 from '../../assets/images/box-item/img2rank.jpg'
import imga1 from '../../assets/images/avatar/author_rank.jpg'
import { Accordion } from 'react-bootstrap-accordion'
import searchTransactionsData from '../../assets/fake-data/data-search-transactions'

const Ranking = () => {
    const [data] = useState([
        {
            id: 1,
            img: img1,
            title: '★ Karambit | Doppler',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            is_popular: 'Yes',
            status: 'Confirming',
            user: 'Phong Henry',
        },
        {
            id: 2,
            img: img2,
            title: 'AWP | Dragon Lore',
            tags: 'Minimal Wear',
            price: '900,000 VNĐ',
            item_float: '0.19734',
            discount: 50,
            phase: 'Phase 2',
            is_popular: 'Yes',
            status: 'Waiting for payment',
            user: 'Hoang Phuong',
        },
        {
            id: 3,
            img: img3,
            title: 'AWP | Gungnir',
            tags: 'Factory New',
            price: '8,100,000 VNĐ',
            item_float: '0.141234',
            discount: 20,
            phase: 'Ruby',
            is_popular: 'No',
            status: 'Paid',
            user: 'Shukuchi',
        },
        {
            id: 4,
            img: img4,
            title: "★ Sport Gloves | Pandora's Box",
            tags: 'Field-Tested',
            price: '8,500,000 VNĐ',
            item_float: '0.005678',
            discount: 24,
            phase: 'Sapphire',
            is_popular: 'No',
            status: 'Delivered',
            user: 'Shukuchi',
        },
        {
            id: 1,
            img: img1,
            title: '★ Karambit | Doppler',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            is_popular: 'Yes',
            status: 'Confirming',
            user: 'Phong Henry',
        },
        {
            id: 2,
            img: img2,
            title: 'AWP | Dragon Lore',
            tags: 'Minimal Wear',
            price: '900,000 VNĐ',
            item_float: '0.19734',
            discount: 50,
            phase: 'Phase 2',
            is_popular: 'Yes',
            status: 'Waiting for payment',
            user: 'Hoang Phuong',
        },
        {
            id: 3,
            img: img3,
            title: 'AWP | Gungnir',
            tags: 'Factory New',
            price: '8,100,000 VNĐ',
            item_float: '0.141234',
            discount: 20,
            phase: 'Ruby',
            is_popular: 'No',
            status: 'Paid',
            user: 'Shukuchi',
        },
        {
            id: 4,
            img: img4,
            title: "★ Sport Gloves | Pandora's Box",
            tags: 'Field-Tested',
            price: '8,500,000 VNĐ',
            item_float: '0.005678',
            discount: 24,
            phase: 'Sapphire',
            is_popular: 'No',
            status: 'Delivered',
            user: 'Shukuchi',
        },
        {
            id: 1,
            img: img1,
            title: '★ Karambit | Doppler',
            tags: 'Minimal Wear',
            price: '100,000 VNĐ',
            item_float: '0.07874',
            discount: 30,
            phase: 'Phase 1',
            is_popular: 'Yes',
            status: 'Confirming',
            user: 'Phong Henry',
        },
        {
            id: 2,
            img: img2,
            title: 'AWP | Dragon Lore',
            tags: 'Minimal Wear',
            price: '900,000 VNĐ',
            item_float: '0.19734',
            discount: 50,
            phase: 'Phase 2',
            is_popular: 'Yes',
            status: 'Waiting for payment',
            user: 'Hoang Phuong',
        },
        {
            id: 3,
            img: img3,
            title: 'AWP | Gungnir',
            tags: 'Factory New',
            price: '8,100,000 VNĐ',
            item_float: '0.141234',
            discount: 20,
            phase: 'Ruby',
            is_popular: 'No',
            status: 'Paid',
            user: 'Shukuchi',
        },
        {
            id: 4,
            img: img4,
            title: "★ Sport Gloves | Pandora's Box",
            tags: 'Field-Tested',
            price: '8,500,000 VNĐ',
            item_float: '0.005678',
            discount: 24,
            phase: 'Sapphire',
            is_popular: 'No',
            status: 'Delivered',
            user: 'Shukuchi',
        },
    ])
    const [visible, setVisible] = useState(6)
    const showMoreItems = () => {
        setVisible((prevValue) => prevValue + 3)
    }
    return (
        <div>
            <Header />
            <section className="tf-section-admin tf-rank">
                <div className="container-fluid">
                    <h2 class="tf-title-heading ct style-2 fs-30 mg-bt-10">Quản lý giao dịch</h2>
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-12">
                            <div id="side-bar" className="side-bar style-3">
                                {searchTransactionsData.map((item, index) => (
                                    <div className="widget widget-category mgbt-24 boder-bt" key={index}>
                                        <div className="content-wg-category">
                                            <Accordion title={item.title} show={true}>
                                                <form action="#">
                                                    {item.content.map((itemm, index) => (
                                                        <div key={index}>
                                                            <label>
                                                                {itemm.field}
                                                                <input type="checkbox" defaultChecked={itemm.checked} />
                                                                <span className="btn-checkbox"></span>
                                                            </label>
                                                            <br />
                                                        </div>
                                                    ))}
                                                </form>
                                            </Accordion>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="col-xl-10 col-lg-10 col-md-12">
                            <div className="table-ranking">
                                <div className="flex th-title">
                                    <div className="column1">
                                        <h3>Items List</h3>
                                    </div>
                                    <div className="column">
                                        <h3>Tags</h3>
                                    </div>
                                    <div className="column">
                                        <h3>Float</h3>
                                    </div>
                                    <div className="column">
                                        <h3>Phase</h3>
                                    </div>
                                    <div className="column">
                                        <h3>Offer Price</h3>
                                    </div>
                                    <div className="column">
                                        <h3>Status</h3>
                                    </div>
                                    <div className="column">
                                        <h3>Action</h3>
                                    </div>
                                </div>
                                {data.slice(0, visible).map((item, index) => (
                                    <div key={index} className="fl-item2">
                                        <div className="item flex">
                                            <div className="infor-item flex column1">
                                                <div className="media">
                                                    <img src={item.img} alt="Axies" />
                                                </div>
                                                <div className="content-collection pad-t-4">
                                                    <h6 className="title mb-15">
                                                        <Link to="/item-detail">{item.title}</Link>
                                                    </h6>
                                                    <div className="author flex">
                                                        <div className="content">
                                                            <h6>Offer by: {item.user}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="column td">
                                                <span>{item.tags}</span>
                                            </div>
                                            <div className="column td2">
                                                <span>{item.item_float}</span>
                                            </div>
                                            <div className="column td3">
                                                <span>{item.phase}</span>
                                            </div>
                                            <div className="column td4">
                                                <span>{item.price}</span>
                                            </div>
                                            <div className="column td6">
                                                <span>{item.status}</span>
                                            </div>
                                            <div className="column td6">
                                                <h6 className="title mb-15">
                                                    <Link>Edit</Link>
                                                </h6>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                {visible < data.length && (
                                    <div className="col-md-12 wrap-inner load-more text-center">
                                        <Link
                                            to="#"
                                            id="load-more"
                                            className="sc-button loadmore fl-button pri-3"
                                            onClick={showMoreItems}
                                        >
                                            <span>Load More</span>
                                        </Link>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Ranking
